import { render, staticRenderFns } from "./TodayMenuItem.vue?vue&type=template&id=3d29c69a"
import script from "./TodayMenuItem.vue?vue&type=script&lang=js"
export * from "./TodayMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports